import { render, staticRenderFns } from "./ScoreReportNav.vue?vue&type=template&id=d401cd36&scoped=true&"
import script from "./ScoreReportNav.vue?vue&type=script&lang=js&"
export * from "./ScoreReportNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d401cd36",
  null
  
)

export default component.exports